
import {Component, Vue} from "vue-property-decorator";
import SafetyFreeTextReport from "@/components/safety/SafetyFreeTextReport.vue";

@Component({
  components: {SafetyFreeTextReport}
})
export default class SafetyReportView extends Vue {

}
